module.exports = __webpack_public_path__ + "media/images/hero_images/security-800-fbf1b513f2a9fe0719d7a556c796119d.jpg";